module.exports = __webpack_public_path__ + "img/HT01077-02.408b50fd.jpg";